import { createContext, useContext, type ReactNode } from "react";

type BrowserWindowChrome = {
  controls: ReactNode;
  maximized: boolean;
  toggleMaximize: () => void;
};

const BrowserWindowChromeContext = createContext<BrowserWindowChrome | null>(null);

export const BrowserWindowChromeProvider = BrowserWindowChromeContext.Provider;

export function useBrowserWindowChrome() {
  return useContext(BrowserWindowChromeContext);
}
